import { ERR_INVALID_ARGUMENT } from "../error";
/**
 * Returns true if the given object is an array. No type conversion will be performed.
 */
export function isArray(pObj) {
    return (Array.isArray(pObj));
}
/**
 * Removes the first element from pArray equal to pElement.
 * Returns true if element was removed.
 */
export function removeElement(pArray, pElement) {
    if (pArray == null)
        return (false);
    const tIndex = pArray.indexOf(pElement);
    if (tIndex !== -1) {
        pArray.splice(tIndex, 1);
        return (true);
    }
    return (false);
}
/**
 * Adds a list of elements to the given array.
 */
export function addElements(pArray, pElements) {
    if (pArray == null || pElements == null)
        return;
    pArray.push(...pElements);
}
/**
 * Inserts a list of elements into the given array.
 */
export function insertElements(pArray, pElements, pInsertIndex) {
    if (pArray == null || pElements == null)
        return;
    for (let i = 0; i < pElements.length; ++i)
        pArray.splice(pInsertIndex + i, 0, pElements[i]);
}
/**
 * Creates a clone of the given array.
 */
export function clone(pArray) {
    if (pArray == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return (pArray.slice(0));
}
/**
 * Returns true if pArray contains pElement.
 */
export function contains(pArray, pElement) {
    if (pArray == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return (pArray.indexOf(pElement) >= 0);
}
/**
 * Clears the given array.
 * Note: Its usually faster to create a new empty array instead of clearing it.
 */
export function clear(pArray) {
    if (pArray == null)
        return;
    pArray.length = 0;
}
/**
 * Returns a new array which only contains the unique entries (no duplicates) of pArray.
 */
export function unique(pArray) {
    if (pArray == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return (Array.from(new Set(pArray)));
}
/**
 * Splits the given array into chunks.
 * Returns an array of arrays with the given chunk size.
 */
export function chunk(pArray, pChunkSize) {
    if (pChunkSize < 1)
        throw new Error(ERR_INVALID_ARGUMENT);
    const tLength = pArray.length;
    const tResult = new Array();
    for (let i = 0; i < tLength; i += pChunkSize) {
        const tChunk = pArray.slice(i, i + pChunkSize);
        tResult.push(tChunk);
    }
    return tResult;
}
